import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const RestoreScroll = () => {
  const prevLocation = useRef();
  const location = useLocation();

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      window.scrollTo(0, 0);
      prevLocation.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
};